import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";
import { waLink } from "@/lib/wa";
import { IMAGES } from "@/constants/images";

export const CTASection = () => {
  const { t } = useLang();
  const { settings } = useSettings();
  return (
    <section className="relative overflow-hidden bg-forest">
      <img src={IMAGES.greenBeansPile} alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" />
      <div className="grain absolute inset-0 opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-4 py-20 text-center sm:px-8 lg:px-12 lg:py-28">
        <div className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.28em] text-amber-soft">Start a Conversation</div>
        <h2 className="mx-auto max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-offwhite sm:text-4xl lg:text-5xl">
          Looking for Indonesian Green Coffee?
        </h2>
        <p className="mx-auto mt-5 max-w-xl font-body text-base leading-relaxed text-offwhite/75">
          Tell us what you are looking for and our team will respond with availability and commercial details.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/request-quote" data-testid="cta-band-quote" className="w-full rounded-full bg-amber-brand px-8 py-4 font-display text-sm font-bold uppercase tracking-wider text-espresso-dark transition-all hover:bg-amber-soft sm:w-auto">
            {t("cta.quote")}
          </Link>
          <a href={waLink(settings.whatsapp)} target="_blank" rel="noreferrer" data-testid="cta-band-whatsapp" className="flex w-full items-center justify-center gap-2 rounded-full border border-offwhite/30 px-8 py-4 font-display text-sm font-bold uppercase tracking-wider text-offwhite transition-all hover:bg-offwhite/10 sm:w-auto">
            <MessageCircle className="h-4 w-4" /> {t("cta.whatsapp")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
